export function getAppEnvConfig() {
  const ENV = import.meta.env as unknown as ViteEnv;

  const { VITE_ENV, VITE_PUBLIC } = ENV;

  return {
    VITE_ENV,
    VITE_PUBLIC,
  };
}

/**
 * 是否为生产模式
 */
export function isLocal(): boolean {
  return process.env.NODE_ENV !== 'production';
}
